export function formatGoodsCategoryListForUI(list = []) {
  if (!Array.isArray(list)) {
    return [];
  }
  const categoryMap = {};
  list.forEach((item) => {
    categoryMap[item.goodsCategoryId] = item;
  });
  return list.map((item) => {
    const category = Object.assign({}, item);
    category.rawCategoryName = category.rawCategoryName || category.categoryName;
    if (
      Number(category.level) === 2 &&
      category.parentId &&
      categoryMap[category.parentId]
    ) {
      const parent = categoryMap[category.parentId];
      const parentName = parent.rawCategoryName || parent.categoryName || "";
      category.categoryName = `${parentName}/${category.rawCategoryName}`;
    }
    return category;
  });
}
